import * as React from 'react';
import Form from '../../common/form/Form';
import { Link } from 'react-router-dom';
import { useState } from 'react';
import FormInput from '../../common/form/Input';

interface Props {
    errorMessage?: string;
    onSubmit: (username: string, password: string) => Promise<boolean>;
}

const LoginForm = (props: Props) => {
    const [wasFormValidated, setWasFormValidated] = useState(false);
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');

    const submitForm = async () => {
        let authSuccess = await props.onSubmit(username, password);
        if (!authSuccess) {
            setPassword('');
        }
    };

    return (
        <Form
            wasFormValidated={wasFormValidated}
            inBootstrapColumn={false}
            submitButtonText="Log In"
            errorMessage={props.errorMessage}
            onSubmit={submitForm}
            onFormValidated={() => setWasFormValidated(true)}
            divClassname="content container col col-md-8 col-lg-6 col-xl-4"
        >
            <h2 className="text-center">
                <u>Admin</u> Log In
            </h2>
            <FormInput
                inputProps={{
                    id: 'username',
                    name: 'username',
                    type: 'username',
                    value: username,
                    required: true
                }}
                labelProps={{
                    labelText: 'Username'
                }}
                onChange={(_name, value) => setUsername(value.toString())}
            />
            <FormInput
                inputProps={{
                    id: 'password',
                    name: 'password',
                    type: 'password',
                    value: password,
                    required: true,
                    minLength: 12
                }}
                labelProps={{
                    labelText: 'Password',
                    invalidText: 'Please enter your password'
                }}
                onChange={(_name, value) => setPassword(value.toString())}
            />
            <div className="form-group">
                <Link className="admin-login-forgot-password" to="/forgotpassword">
                    Forgot your password?
                </Link>
            </div>
        </Form>
    );
};

export default LoginForm;



// WEBPACK FOOTER //
// ./src/components/pages/auth/LoginForm.tsx